export const styles = {
  flightPath: {
    color: "#f00",
    weight: 2,
    opacity: 0.8,
  },
  county: {
    color: "#000000",
    fillOpacity: 0,
    weight: 3,
    opacity: 0.5,
  },
  approximateArea: {
    color: "#56b3d2",
    weight: 1,
    fillColor: "#56b3d2",
    fillOpacity: 0.5,
  },
};
